import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { getPaginationPayload } from '~/utils/pagination';
import { IIcd10CodesStore, IThunkGetIcd10Codes } from '../types';

const onGetIcd10Codes: IThunkGetIcd10Codes = thunk(
  // @ts-ignore
  async ({ setIcd10Codes, reset }, filters, { getState }) => {
    reset();

    const localState = getState() as IIcd10CodesStore;
    const paginationPayload = getPaginationPayload(localState.pagination);

    const { data } = await api.icd10Codes.getList({
      ...filters,
      ...paginationPayload,
    });

    setIcd10Codes(data);
  },
);

export default onGetIcd10Codes;
